<div style="display: flex; align-items: center; flex-direction: row; justify-content: center; padding: 30px 0">
	<p class="mat-caption">{{ 'logout.label' | translate }}</p>
</div>
